import type { FlexProps } from "@qws-org/ui-kit";
import { Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { PagePreview } from "~/core";

import { InfoPageListItem } from "./components/InfoPageListItem";

export type InfoPageListProps = {
  data: Array<PagePreview>;
  isActive: (page: PagePreview) => boolean;
  getPageUrl: (page: PagePreview) => string;
  className?: string;
} & FlexProps;

export const InfoPageList: FC<InfoPageListProps> = ({
  data,
  getPageUrl,
  isActive,
  className = "",
  ...rest
}) => {
  return (
    <Flex flexDirection="column" className={className} {...rest}>
      {data.map((item) => (
        <InfoPageListItem
          key={item.id}
          page={item}
          isActive={isActive(item)}
          getPageUrl={getPageUrl(item)}
        />
      ))}
    </Flex>
  );
};
